import PaymentController from './payment.model';

export default class PaymentMoneyController extends PaymentController {
  _data_money = {
    payment_account_id: null,
    payment_historic_id: null,
    payment_credit_date: null,
    document_historic_id: null
  }
  _data = {
    ...this._data, // usa o objeto herdado
    ...this._data_money
  }

  constructor(input) {
    super(input)
    this._data.payment_type = "money"
    this._data.payment_discount_type = "V"
    this._data.payment_interest_type = "V"
    this._data.payment_fine_type = "V"
    this._data.payment_account_id = 7,
    this._data.payment_historic_id = 12,
    this._data.document_historic_id = 14,
    this._data.rate_historic_id = 108,
    this._data.rate_currency_id = 1,

    this.setData(input, this._data)
  }
}